import { render, staticRenderFns } from "./RankedChart.vue?vue&type=template&id=4ee6b46e"
import script from "./RankedChart.vue?vue&type=script&lang=js"
export * from "./RankedChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports